import { render, staticRenderFns } from "./StorageLocationView.vue?vue&type=template&id=79975c2a&scoped=true"
import script from "./StorageLocationView.vue?vue&type=script&lang=js"
export * from "./StorageLocationView.vue?vue&type=script&lang=js"
import style0 from "./StorageLocationView.vue?vue&type=style&index=0&id=79975c2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79975c2a",
  null
  
)

export default component.exports